// extracted by mini-css-extract-plugin
export default {"selected":"_4d10826aa3","un":"_78906971fc"};